import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getUserData, saveUserData } from '../../Utilities/storageHelpers';

interface UserState {
  currentUser: any;
}

const persistedUser = getUserData();

const initialState: UserState = {
  currentUser: persistedUser,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUser(state, action: PayloadAction<any>) {  
      state.currentUser = action.payload;
      if (action.payload) {
        saveUserData(action.payload);
      }
    },
    clearCurrentUser(state) {
      state.currentUser = null;
    },
    restoreUserFromStorage(state) {
      const userData = getUserData();
      state.currentUser = userData;
    },
  },
});

export const { setCurrentUser, clearCurrentUser, restoreUserFromStorage } = userSlice.actions;
export default userSlice.reducer;
